"use client";

import React, { memo, useState } from "react";
import { TooltipProvider } from "@radix-ui/react-tooltip";
import { Award, CalendarCheck, ChevronDown, ChevronUp, Crown, Heart, MessageCircle, MessageSquare, Star, Target, ThumbsUp, Trophy, UserPlus, Zap } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { TaskDTO } from "@/types";
interface AchievementPillsProps {
  achievements?: TaskDTO[];
  initialDisplayCount?: number;
}
const iconMap = {
  Star: Star,
  Trophy: Trophy,
  Target: Target,
  Zap: Zap,
  Award: Award,
  Crown: Crown,
  ThumbsUp: ThumbsUp,
  UserPlus: UserPlus,
  MessageSquare: MessageSquare,
  CalendarCheck: CalendarCheck,
  MessageCircle: MessageCircle,
  Heart: Heart
};
const AchievementSection = ({
  achievements,
  initialDisplayCount = 6
}: AchievementPillsProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const displayAchievements = achievements && achievements.length > 0 ? achievements : [];
  const displayedAchievements = isExpanded ? displayAchievements : displayAchievements.slice(0, initialDisplayCount);
  const hasMore = displayAchievements.length > initialDisplayCount;
  return <div className="w-full space-y-4" data-sentry-component="AchievementSection" data-sentry-source-file="index.tsx">
            <div className="flex flex-wrap gap-2">
                {displayedAchievements.map(achievement => <Badge key={achievement.id} className={cn("inline-flex items-center gap-1.5 py-1 px-2 text-xs cursor-default", "transition-colors duration-200", !achievements && "opacity-50")} style={{
        borderColor: achievement.badgeColor,
        color: achievement.badgeColor
      }}>
                        <TooltipProvider key={achievement.id}>
                            <Tooltip key={achievement.id}>
                                <TooltipTrigger asChild key={achievement.id}>
                                    <div className="flex items-center gap-1">
                                        {achievement.badgeIcon && React.createElement(iconMap[achievement.badgeIcon as keyof typeof iconMap] || Trophy, {
                  size: 12,
                  style: {
                    color: achievement.badgeColor
                  }
                })}
                                        {achievement.badgeName}
                                    </div>
                                </TooltipTrigger>
                                <TooltipContent>
                                    <p>{achievement.description}</p>
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                    </Badge>)}
            </div>

            {hasMore && <Button variant="ghost" size="sm" className="w-full flex items-center justify-center gap-2 hover:bg-slate-900" onClick={() => setIsExpanded(!isExpanded)}>
                    {isExpanded ? <>
                            Show Less <ChevronUp className="h-4 w-4" />
                        </> : <>
                            Show More <ChevronDown className="h-4 w-4" />
                        </>}
                </Button>}
        </div>;
};
export default memo(AchievementSection);